import { render, staticRenderFns } from "./AdminAppPaidShowItem.vue?vue&type=template&id=112f51ac&scoped=true"
import script from "./AdminAppPaidShowItem.vue?vue&type=script&lang=js"
export * from "./AdminAppPaidShowItem.vue?vue&type=script&lang=js"
import style0 from "./AdminAppPaidShowItem.vue?vue&type=style&index=0&id=112f51ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112f51ac",
  null
  
)

export default component.exports